import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

/** Takes a skill back out of the library. Staff act on a company that is not their own, so they
 * pass its id: that goes through the staff route and refreshes that company's skills. */
export default function useUnshareTenantSkill(companyId?: string) {
  const queryClient = useQueryClient();

  return useMutation<unknown, Error, string>({
    mutationFn: skillId =>
      api.delete(
        companyId === undefined
          ? `/tenant/custom-skills/${skillId}/share`
          : `/admin/companies/${companyId}/custom-skills/${skillId}/share`,
      ),
    onSettled: () => {
      if (companyId !== undefined) {
        return queryClient.invalidateQueries({
          queryKey: ['admin', 'companies', companyId, 'custom-skills'],
        });
      }
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: ['tenant', 'custom-skills'] }),
        queryClient.invalidateQueries({ queryKey: ['skill-library'] }),
      ]);
    },
  });
}
